<template>
  <div class="w-full overflow-hidden">
    <heading v-if="doc.show_heading" :title="doc.page_title" />
    <LandingPage v-if="doc.is_landing" :key="doc.web_page_id" :doc="doc" />
    <WebContent v-else :doc="doc" />
  </div>
</template>

<script setup>
const props = defineProps({
  doc: {
    type: Object,
    required: true
  }
})
</script>

<style lang="scss"></style>
